exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".demo-table-expand[data-v-2711121c]{font-size:0}.demo-table-expand label[data-v-2711121c]{width:96px;color:#99a9bf}.demo-table-expand .el-form-item[data-v-2711121c]{margin-right:0;margin-bottom:0;width:50%}.el-form-item__content>a[data-v-2711121c]{color:#1890ff}.el-form-item__content>a[data-v-2711121c]:hover{color:#4ba9ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2711121c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/customer/Orders.vue
// module id = 1896
// module chunks = 0